import { createSlice } from "@reduxjs/toolkit";

const summarySlice = createSlice({
    name: "summary",
    initialState: {
        isLoading: true,
        summaryList: []
    },
    reducers: {
        setSummaryLoading: (state, { payload }) => {
            state.isLoading = payload;
        },
        setSummaryData: (state, { payload }) => {
            state.summaryList = payload;
        }
    }
});

export const { setSummaryLoading, setSummaryData } = summarySlice.actions

export default summarySlice.reducer;